// extracted by mini-css-extract-plugin
export default {"spinnerModal":"SpinnerModal_spinnerModal__mJemL"};